import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import PaymentFlow from "./pages/PaymentFlow";
import StudentRegistration from "./pages/StudentRegistration";
import "./styles/App.css";

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/payment" replace />} />
        <Route path="/payment" element={<PaymentFlow />} />
        <Route path="/register" element={<StudentRegistration />} />
        <Route path="*" element={<Navigate to="/payment" replace />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
